module.exports = __webpack_public_path__ + "media/images/card_logos/visa-logo-b56eab984bb0efecbbbd84e296751f66.gif";